fragment LeadSearchResult on Lead {
    id
    number
    name: htmlName
    htmlUrlPath
    avatarUrl
    status
    priority
    overdueTime
    contacts {
        primaryEdge {
            node {
                id
                type
                htmlUrl
                name
            }
        }
    }
    accounts {
        primaryEdge {
            node {
                id
                type
                htmlUrl
                name
            }
        }
    }
    value {
        formatted
        formattedValue {
            formatted
            prefix
            suffix
            value
        }
    }
}
